/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { CellStatus } from './cell-status.enum';
import { CalendarTask } from './calendar-task';
import { CalendarUtils } from './calendar-utils';
import { Dayjs } from 'dayjs';
import { CommonUtils } from '../../tool/common-utils';

export class CalendarCell {
  day: Dayjs;
  duration: number;
  label: string;
  selected: boolean;
  status: CellStatus = CellStatus.enable;
  backgroundColor = '';
  isCurrent = false;
  isOff = false;
  hasTelework = false;

  public tasks: {
    task: CalendarTask;
    type: 'full' | 'start' | 'part' | 'end';
  }[] = [];
  public totalTasksDuration = 0;

  constructor(day: Dayjs, status?: CellStatus) {
    this.day = day;
    this.label = day.get('date') + '';
    this.isCurrent = CommonUtils.isToday(day.toDate());
    if (status) {
      this.status = status;
    }
  }

  public addTask(task: CalendarTask) {
    let positionFlag: 'full' | 'start' | 'part' | 'end' = 'full';
    if (task.dateEnd) {
      const compareStart = CalendarUtils.compareDMY(task.dateStart, this.day);
      const compareEnd = CalendarUtils.compareDMY(task.dateEnd, this.day);
      if (compareStart && compareEnd) {
        positionFlag = 'full';
      } else if (compareStart) {
        positionFlag = 'start';
      } else if (compareEnd) {
        positionFlag = 'end';
      } else {
        positionFlag = 'part';
      }
    }
    this.tasks.push({
      task: task,
      type: positionFlag,
    });
    this.computeTotalTasksDuration();
  }

  computeTotalTasksDuration() {
    let total = 0;
    for (const task of this.tasks) {
      const taskDuration = CommonUtils.convertStrToTime(task.task.getDuration())
      total += (taskDuration.hours * 60 + taskDuration.minutes)
    }
    this.totalTasksDuration = total;
  }
}
